import { Spend } from 'components/common/Spend'
import {
  makeLeadsGetRequest,
  makeLeadsPostRequest,
  makeLeadsPutRequest,
  makeLeadsDeleteRequest
} from 'utils/api'

const LeadSpend = ({ leadId }) => {
  const makeSpendGetRequest = async () =>
    leadId && (await makeLeadsGetRequest(`/v1/leads/${leadId}/spend`))

  const makeSpendPostRequest = async itemDetails =>
    await makeLeadsPostRequest(`/v1/leads/${leadId}/spend-item`, itemDetails)

  const makeSpendPutRequest = async (itemId, itemDetails) =>
    await makeLeadsPutRequest(`/v1/leads/spend-item/${itemDetails.id}`, itemDetails)

  const makeSpendDeleteRequest = async itemId =>
    await makeLeadsDeleteRequest(`/v1/leads/${leadId}/spend-item/${itemId}`)

  return (
    <div>
      <Spend
        makeGetRequest={makeSpendGetRequest}
        makePostRequest={makeSpendPostRequest}
        makePutRequest={makeSpendPutRequest}
        makeDeleteRequest={makeSpendDeleteRequest}
      />
    </div>
  )
}

export default LeadSpend
